// this is an autogenerated file from DesignSystem/ManualAutomations/Content/Content/ActiveAction/TaskInsertNew/Actions/Content/Action/DocumentTemplate/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_ManualAutomations_Content_Content_ActiveAction_TaskInsertNew_Actions_Content_Action_DocumentTemplate($organization_id: uuid!) {
  vaxiom_document_templates(
    where: { organization: { _id: { _eq: $organization_id } } }
    order_by: { name: asc_nulls_last }
  ) {
    vaxiom_id: id
    id: _id
    text: name
  }
}

`